import React from 'react';

export const EditorContext: React.Context<Record<string, unknown>> =
	React.createContext({});
